import React, {Component, CSSProperties} from 'react';
import styles from './bonusPage.module.scss';
import BonusCard from "./bonusCard/bonusCard";
import BonusCardMobile from "./bonusCard/bonusCardMobile";
import {BonusCardModel} from "./bonusCard/model";
import BonusStub from '../bonusStub/bonusStub';
import { Popup } from "semantic-ui-react";
import stylesForPopup from "../../styles/donor_card.module.scss";

export default class BonusPage extends Component<any, any> {
  props: {
    bonuses: BonusCardModel[];
    showStatus?: boolean;
    title?: string;
    desktop?: boolean;
    mobile?: boolean;
    noMarginTop?: boolean;
    titleAdditionalClass?: boolean;
    bonusMetrics?: string;
    marginTop?: CSSProperties['marginTop'];
    paddingContainer?: CSSProperties['padding'];
    isHidden?: boolean
    isShow?: boolean
    infoTooltip?: string
  }

  render() {
    const {
      bonuses,
      title = 'Бонусы',
      showStatus = true,
      desktop = true,
      titleAdditionalClass = false,
      mobile = true,
      noMarginTop = false,
      bonusMetrics,
      marginTop,
      paddingContainer,
      isHidden,
      isShow,
      infoTooltip
    } = this.props

    return (
      <div style={marginTop ? {marginTop: marginTop} : null}
           className={noMarginTop ? styles.BonusPageMoMarginTop : styles.BonusPage}>
        <div className={'container'}>
          <div style={paddingContainer ? {padding: paddingContainer} : null}
            className={styles.BonusPageContainer}>
              {
                !infoTooltip ?
                <div
                  className={titleAdditionalClass ? styles.BonusPageContainerTitle + ' ' + styles.TitleAdditionalClass : styles.BonusPageContainerTitle}>
                  <h1>{title}</h1>
                </div>
                :
                <div className={styles.BonusPageContainerTitleWithTooltip}>
                  <span>
                    {title}{" "}
                    <Popup
                      flowing
                      hoverable
                      className={stylesForPopup.Popups}
                      inverted
                      basic
                      style={{ backgroundColor: "#333333" }}
                      mouseLeaveDelay={500}
                      position={"right center"}
                      trigger={
                        <img
                          src="/static/images/icons/kellPopup.svg"
                          alt=""
                        />
                      }
                    >
                      <p>
                        {infoTooltip}
                      </p>
                    </Popup>
                  </span>
                </div>
              }
            <div className={styles.BonusPageContainerContent}>
              {bonuses && desktop && bonuses.map((bonus) => {
                return <BonusCard
                  key={bonus.id}
                  info={bonus}
                  showStatus={showStatus}
                  metricsOnClick={bonusMetrics}/>
              })}
              {bonuses && mobile && bonuses.map((bonus) => {
                return <BonusCardMobile
                  key={bonus.id + '_mobile'}
                  info={bonus}
                  showStatus={showStatus}
                  metricsOnClick={bonusMetrics}/>
              })}
              { !isShow &&
                (
                  isHidden ?
                  <div className={styles.StubWrapper}>
                    <BonusStub />
                  </div>
                  :
                  <BonusStub />
                )
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

